import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderUpload"><Path d="M16.5 19.5H21.5V6.5H12L10 3.5H2.5V19.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 19.5V14" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M14.5 15.5L12 13L9.5 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderUpload;
